import { SelectOption } from "@idw-types/common";
import { PolicyDecisionOperationTypes } from "../enums/policy-decision-operation-types";

export const POLICY_DECISION_OPERATION_TYPE_OPTIONS: Array<SelectOption> = [
    { label: "AND", value: PolicyDecisionOperationTypes.AND },
    { label: "OR", value: PolicyDecisionOperationTypes.OR }
];